import { MapPin, Clock, Phone, Bus } from 'lucide-react';

const LocationPage = () => {
  const googleMapsUrl = "https://www.google.com/maps/dir/?api=1&destination=46.94298046841302,7.436602879234022";

  return (
    <div data-testid="location-page" className="min-h-screen pt-20 bg-[#050a09]">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-[#050a09]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-4 font-['Manrope']">
              THE SHAMROCK
            </p>
            <h1 className="font-['Playfair_Display'] text-4xl md:text-6xl lg:text-7xl font-bold text-[#E8E6D9] mb-4">
              GRÜEZI, BÄRN!
            </h1>
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-px bg-[#D4AF37]"></div>
              <span className="mx-4 text-[#D4AF37] text-2xl">☘</span>
              <div className="w-12 h-px bg-[#D4AF37]"></div>
            </div>
            <p className="text-[#E8E6D9]/80 font-['Manrope'] text-lg">
              Your Irish Pub in the Heart of Bern.
            </p>
          </div>

          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Map Section */}
            <div className="space-y-4">
              {/* Google Map Embed */}
              <div className="relative bg-[#1a1a1a] rounded-sm overflow-hidden border border-[#D4AF37]/30" style={{ height: '450px' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1361.7!2d7.4366!3d46.9430!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478e39a9c8b4f7b1%3A0x8c8b8c8b8c8b8c8b!2sSchwarzorstrasse%2011%2C%203007%20Bern%2C%20Switzerland!5e0!3m2!1sen!2sch!4v1700000000000!5m2!1sen!2sch"
                  width="100%"
                  height="100%"
                  style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg)' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="The Shamrock Location"
                ></iframe>
                {/* Custom Shamrock Marker Overlay */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-full pointer-events-none z-10">
                  <div className="flex flex-col items-center">
                    <div className="bg-[#D4AF37] text-[#050a09] px-3 py-1 rounded-md text-xs font-bold font-['Manrope'] whitespace-nowrap shadow-lg mb-1">
                      The Shamrock
                    </div>
                    <span className="text-[#D4AF37] text-3xl drop-shadow-lg" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}>☘</span>
                  </div>
                </div>
              </div>

              {/* Get Directions Button */}
              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="get-directions-btn"
                className="flex items-center justify-center gap-3 w-full border border-[#D4AF37] text-[#D4AF37] px-8 py-4 rounded-sm font-['Manrope'] font-semibold text-sm tracking-wider uppercase hover:bg-[#D4AF37] hover:text-[#050a09] transition-all duration-300"
              >
                <MapPin size={20} />
                GET DIRECTIONS
              </a>
            </div>

            {/* Info Section */}
            <div className="space-y-8">
              {/* Address */}
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#D4AF37] text-2xl">☘</span>
                </div>
                <div>
                  <h3 className="text-[#D4AF37] font-['Manrope'] font-bold text-sm tracking-wider uppercase mb-2">
                    ADDRESS
                  </h3>
                  <p className="text-[#E8E6D9] font-['Manrope']">The Shamrock Irish Pub Bern</p>
                  <p className="text-[#E8E6D9] font-['Manrope']">Schwarztorstrasse 11</p>
                  <p className="text-[#E8E6D9] font-['Manrope']">3007 Bern, Switzerland</p>
                </div>
              </div>

              {/* Opening Hours */}
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Clock size={24} className="text-[#D4AF37]" />
                </div>
                <div>
                  <h3 className="text-[#D4AF37] font-['Manrope'] font-bold text-sm tracking-wider uppercase mb-2">
                    OPENING HOURS
                  </h3>
                  <div className="space-y-1 text-[#E8E6D9] font-['Manrope']">
                    <div className="flex justify-between gap-8">
                      <span>Monday – Thursday</span>
                      <span>11:00 – 23:00</span>
                    </div>
                    <div className="flex justify-between gap-8">
                      <span>Friday</span>
                      <span>11:00 – 01:00</span>
                    </div>
                    <div className="flex justify-between gap-8">
                      <span>Saturday</span>
                      <span>16:00 – 01:00</span>
                    </div>
                    <div className="flex justify-between gap-8">
                      <span>Sunday</span>
                      <span>16:00 – 23:00</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact */}
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone size={24} className="text-[#D4AF37]" />
                </div>
                <div>
                  <h3 className="text-[#D4AF37] font-['Manrope'] font-bold text-sm tracking-wider uppercase mb-2">
                    CONTACT
                  </h3>
                  <p className="text-[#E8E6D9] font-['Manrope']">
                    <a href="tel:+41337227000" className="hover:text-[#D4AF37] transition-colors">
                      033 722 7000
                    </a>
                  </p>
                  <p className="text-[#D4AF37] font-['Manrope']">
                    <a href="mailto:bern@theshamrock.ch" className="hover:underline">
                      bern@theshamrock.ch
                    </a>
                  </p>
                </div>
              </div>

              {/* How to Get Here */}
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Bus size={24} className="text-[#D4AF37]" />
                </div>
                <div>
                  <h3 className="text-[#D4AF37] font-['Manrope'] font-bold text-sm tracking-wider uppercase mb-2">
                    HOW TO GET HERE
                  </h3>
                  <div className="space-y-1 text-[#E8E6D9] font-['Manrope'] text-sm">
                    <p><span className="font-semibold">Tram:</span> Monbijou / Hasler</p>
                    <p><span className="font-semibold">Bus:</span> Monbijou</p>
                    <p><span className="font-semibold">On Foot:</span> 5 min. from Bern Main Station</p>
                    <p><span className="font-semibold">Bike:</span> Bike parking nearby</p>
                    <p><span className="font-semibold">Car:</span> Parking available nearby. Public transport recommended.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LocationPage;
